import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

const I18N_PATH = './assets/i18n/';

/**
 * Cache-busting string for i18n JSON URLs, per deploy. Reads the `build-commit`
 * meta tag CI injects into index.html; must match index.html's preload script.
 * Fallback: timestamp (local dev, where the meta tag is absent).
 */
function getI18nCacheBuster(): string {
    try {
        if (typeof document !== 'undefined') {
            const commit = document.querySelector('meta[name="build-commit"]')?.getAttribute('content');
            if (commit) return commit;
        }
    } catch {
        // ignore
    }
    return String(Date.now());
}

export function provideAppTranslateHttpLoader() {
    const suffix = `.json?v=${getI18nCacheBuster()}`;
    return provideTranslateHttpLoader({
        prefix: I18N_PATH,
        suffix,
    });
}
